const choices = {
    monthly: 'Mensuelle',
    annual: 'Annuelle',
};

export default choices;
